module.exports = __webpack_public_path__ + "img/gzy.cbc97f74.jpeg";